module.exports = __webpack_public_path__ + "static/media/9_l_vaza2_26.82_83.15.9d4e6d05.png";